import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import HeroHome from './HeroHome';
import HeroSection from './HeroSection';
import DealsSection from './DealsSection';
import HowItWorks from './HowItWorks';
import Footer from './Footer';
import Login from './Login';
import Signup from './Signup';
import Dashboard from './Dashboard';
import CreateDeal from './CreateDeal';
import DealDetails from './DealDetails';
import Payment from './Payment';
import Coupon from './Coupon';
import BackToTopButton from './BackToTopButton';
import TeaserSection from './TeaserSection';
import TrustSection from './TrustSection';
import LiveSavingsSection from './LiveSavingsSection';
import CaseStudiesSection from './CaseStudiesSection';
import SignupSection from './SignupSection';
import WelcomeSection from './WelcomeSection';
import AffiliateDealsSection from './AffiliateDealsSection';
import MerchantDashboard from './MerchantDashboard';
import MerchantLogin from './MerchantLogin';
import MerchantSignup from './MerchantSignup';
import MerchantLanding from './MerchantLanding';
import StaffDashboard from './StaffDashboard';
import StaffLogin from './StaffLogin';
import StaffSignup from './StaffSignup';
import StaffLanding from './StaffLanding';
import PrivacyPolicy from "./PrivacyPolicy";
import TermsAndConditions from "./TermsAndConditions";
import About from './About';
import Faqs from './Faqs';
import PartnerWithUs from './PartnerWithUs';
import GoldPage from './GoldPage';
import GoldLanding from './GoldLanding';
import ContactForm from './ContactForm';




const GOOGLE_CLIENT_ID = '419499731991-32au01h15f7o8jltocivs4hdhlts6pis.apps.googleusercontent.com';

const Home = () => (
  <>
    <HeroSection />
     <HeroHome />
    <TeaserSection />
    <TrustSection />
    <LiveSavingsSection />
    <CaseStudiesSection />
    <SignupSection />
    <DealsSection />
    <AffiliateDealsSection />
    <HowItWorks />
    <WelcomeSection />
    <Footer />
  </>
);

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Router>
        <Routes>
          
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/merchant-login" element={<MerchantLogin />} />
          <Route path="/merchant-signup" element={<MerchantSignup />} />
          <Route path="/merchant" element={<MerchantLanding />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/merchant-dashboard" element={<MerchantDashboard />} />
          <Route path="/staff" element={<StaffLanding />} />
          <Route path="/staff-login" element={<StaffLogin />} />
          <Route path="/staff-signup" element={<StaffSignup />} />
          <Route path="/staff-dashboard" element={<StaffDashboard />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/about" element={<About />} />
          <Route path="/ContactForm" element={<ContactForm />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/partner-with-us" element={<PartnerWithUs />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/gold-dashboard" element={<GoldPage />} />
          <Route path="/gold" element={<GoldLanding />} />
          <Route path="/create-deal" element={<CreateDeal />} />
          <Route path="/deals" element={<DealsSection />} />
          <Route path="/deals/:dealId" element={<DealDetails />} />
          <Route path="/payment/:dealId" element={<Payment />} />
          <Route path="/coupon/:couponCode" element={<Coupon />} />
          
        </Routes>
        <BackToTopButton />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;